import { UniDriver } from '@wix/wix-ui-test-utils/dist/types/unidriver';

/** @deprecated to be replaced with export(s) from uni-driver packages(s) */
export const isReactLegacy = (base: UniDriver) => base.type === 'react';
/** @deprecated to be replaced with export(s) from uni-driver packages(s) */
export const isReactNew = (base: UniDriver) => base.type === 'react';
